namespace Umbrella.ChatConversationHandling {
    @Pipe('Chat', 'messageDirection')
    class ChatConversationPendingStatusFilter {
        public transform(message: ChatMessage) {
            return message && message.direction === MessageDirections.toCustomer ? 'from-me' : 'from-them';
        }
    }
}
